module.exports = __webpack_public_path__ + "img/ch21_10_记忆归来.264c4503.jpg";